import { getAxiosBackendApi3, getAuthAxiosBackendApi3 } from "../../helpers/axios"
import User from '../../helpers/user';

export const state = {
    toLocaleString: false,
    token: getState('token'),
    user: getState('user'),
}

export const mutations = {
    setToken(state, token) {
        state.token = token
        saveState('token', token, state.toLocaleString)
    },
    setUser(state, user) {
        if(user != null)
        state.user = new User(
            user.id,
            user.name,
            user.description,
            user.username,
            user.active,
        )
        saveState('user', state.user, state.toLocaleString)
    }
}

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.token
    },
    getToken(state){
        return state.token
    },
    getUser(state){
        return state.token != null ? 
        new User(
            state.user.id,
            state.user.name,
            state.user.description,
            state.user.username,
            state.user.active,
        ) : null
    }
}

export const actions = {

    logIn( { commit , dispatch, getters }, { username, password , remember} = {}) {
        state.toLocaleString = remember
        
        if (getters.loggedIn) return dispatch('validate')

        return getAxiosBackendApi3().post('auth/login', {
            username:username,
            password:password,
        })
        .then((response)=>{
            const token = response.data
            commit('setToken', token);
            
            return dispatch('my')
        });
    },
    
    validate({ state, dispatch }) {
        if (!state.token) return Promise.resolve(null)

        if(process.env.VUE_APP_API_VALIDATE_TOKEN == 'serverSide')
        {
            return dispatch('my')
            .catch((error)=>{
                dispatch('logOutClientSide')
                return error
            })
        }else{ //client Side
            Promise.resolve(200) 
        }
    },

    my({ commit }){
        return getAuthAxiosBackendApi3().get('auth/my')
            .then((response)=>{
                commit('setUser', response.data.data)
                return 200;
            })
    },

    logOut({dispatch}) {
        return getAuthAxiosBackendApi3().post('auth/logout')
        .then((response)=>{
            return response
        })
        .finally(()=>{
            dispatch('logOutClientSide')
        })
    },

    logOutClientSide({ commit }){
        commit('setToken', null)
        commit('setUser', null)
        clearState();
    },

    changePassword({commit}, {old_password, new_password, new_password_confirmation}){
        commit('', '')
        return getAuthAxiosBackendApi3().put('auth/change/password', {
            old_password: old_password,
            new_password: new_password,
            new_password_confirmation: new_password_confirmation,
        })
    },

    changeUsername({commit}, {username}){
        return getAuthAxiosBackendApi3().put('auth/change/username', {
            username: username
        }).then((response)=>{
            commit('setUsername', username)
            return response
        })
    },

    checkUserName({commit}, data){
        commit('', '')
        return getAuthAxiosBackendApi3().post('auth/checkUserName', data);
    }
}

// ===
// Private helpers
// ===

function saveState(key, state, toLocaleString) {
    if(toLocaleString) window.localStorage.setItem(key, JSON.stringify(state))
    else window.sessionStorage.setItem(key, JSON.stringify(state));
}
function getState(key){
    return JSON.parse(
        window.sessionStorage.getItem(key) ?? window.localStorage.getItem(key)
    )
}

function clearState(){
    window.localStorage.clear()
    window.sessionStorage.clear()
}
